module.exports = __webpack_public_path__ + "images/5f9551ae59160f81d00f05cd588bdf51-profile_overlay.jpg";